module.exports = __webpack_public_path__ + "static/media/mail.fd41df62.svg";